module.exports = __webpack_public_path__ + "img/Lisa_Song.bff30191.png";